import { createElement, type ReactNode } from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';
import { StatisticSectionRow } from './types';
import styles from './style.module.css';

const renderParameter = (
  _value: StatisticSectionRow['parameter'],
  record: StatisticSectionRow,
): ReactNode => {
  const parameterContent = renderParameterText(record.parameter);
  return createElement(
    'span',
    { className: styles.parameterContent },
    parameterContent,
    record.subtitle
      ? createElement('span', { className: styles.subtitle }, record.subtitle)
      : null,
    record.tooltip
      ? createElement(
          Tooltip,
          { title: record.tooltip },
          createElement(InfoCircleOutlined, {
            'aria-label': 'Описание показателя',
            className: styles.categoryTooltipIcon,
          }),
        )
      : null,
  );
};

const PARENTHETICAL_SUFFIX_PATTERN = /^(.*?)(\s+\([^)]*\))$/;

const renderParameterText = (parameter: string): ReactNode => {
  const match = PARENTHETICAL_SUFFIX_PATTERN.exec(parameter);

  if (!match) {
    return parameter;
  }

  const [, baseParameter, suffix] = match;

  if (!baseParameter || !suffix) {
    return parameter;
  }

  return createElement(
    'span',
    null,
    baseParameter,
    createElement('span', { className: styles.categoryTitleSuffix }, suffix),
  );
};

const renderValue = (
  value: StatisticSectionRow['value'] | StatisticSectionRow['percent'],
) => value ?? '';

const PARAMETER_COLUMN_WIDTH = '70%';
const NUMERIC_COLUMN_WIDTH = '15%';

export const COLUMNS: ColumnsType<StatisticSectionRow> = [
  {
    title: 'Показатель',
    dataIndex: 'parameter',
    align: 'left',
    width: PARAMETER_COLUMN_WIDTH,
    className: styles.parameterCell,
    render: renderParameter,
    onCell: () => ({
      className: styles.parameterCell,
    }),
  },
  {
    title: 'Значение',
    dataIndex: 'value',
    align: 'right',
    width: NUMERIC_COLUMN_WIDTH,
    className: styles.numericCell,
    render: renderValue,
    onCell: () => ({
      className: `${styles.rightAlignedCell} ${styles.numericCell}`,
    }),
  },
  {
    title: 'Доля от всех',
    dataIndex: 'percent',
    align: 'right',
    width: NUMERIC_COLUMN_WIDTH,
    className: styles.numericCell,
    render: renderValue,
    onCell: () => ({
      className: `${styles.rightAlignedCell} ${styles.numericCell}`,
    }),
  },
];
